import VisaLogo from 'assets/visaLogo.png'
import MastercardLogo from 'assets/mastercardLogo.png'
import MaestroLogo from 'assets/maestroLogo.png'
import UnionPayLogo from 'assets/unionPayLogo.png'
import AmexLogo from 'assets/amexLogo.png'
import DiscoverLogo from 'assets/discoverLogo.png'
import { PaymentIcon } from 'ui/icons'
import styled from 'styled-components'

const Img = styled.img`
    width: 32px;
    height: 20px;
    object-fit: contain;
`

export const cardTypeLogos = {
    visa: {name: 'visa', img: <Img src={VisaLogo} />},
    mastercard: {name: 'mastercard', img: <Img src={MastercardLogo} />},
    maestro: {name: 'maestro', img: <Img src={MaestroLogo} />},
    unionpay: {name: 'unionpay', img: <Img src={UnionPayLogo} />},
    amex: {name: 'american express', img: <Img src={AmexLogo} />},
    discover: {name: 'discover', img: <Img src={DiscoverLogo} />},
    new: {name: 'new', img: <PaymentIcon />}
}
